import store from "../store";
const TokenKey = "UserToken";
const TicketKey = "Ticket";
const Identity = "Identity";

export function setToken(token) {
  store.commit("SET_TOKEN",token)
  let atoken = store.state.user.token
  console.log("token:"+atoken)
}

export function getToken() {
  let token = store.state.user.token
  return token
}

export function removeToken() {
  store.commit("SET_TOKEN",null);
}
export function setTokenExpiryDate(tokenExpiryDate) {
  store.commit("SET_TOKEN_EXPIRY_DATE",tokenExpiryDate);
}


export function getTokenExpiryDate() {
  return store.state.user.tokenExpiryDate;
}

export function reomoveTokenExpiryDate() {
  store.commit("SET_TOKEN_EXPIRY_DATE",null)
}

export function setTicket(ticket) {
  store.commit("SET_TICKET",ticket)
}

export function getTicket() {
  let tiket = store.state.user.ticket
  return tiket;
}

export function removeTicket() {
  store.commit("SET_TICKET",null)
}

export function setIdentity(identity) {
  store.commit("SET_USER_IDENTITY",identity)
}

export function getIdentity() {
  let user = store.state.user
  let userIdentity = store.state.user.userIdentity
  return userIdentity;
}

export function removeIdentity() {
  store.commit("SET_USER_IDENTITY",null)
}
